import * as crowPortrayal from '../services/crowdPortrayal';

export default {
  namespace: 'crowPortrayal',
  state: {
    chartDetail: {},
    groupInfo: {},
  },

  effects: {
    //获取图表
    *groupTagChartList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowPortrayal.getChartDetail, { ...values });
      yield put({
        type: 'save',
        payload: {
          chartDetail: response?.data,
        },
      });
      if (response.code === 0 && callback && typeof callback === 'function') {
        return callback(response.data);
      }
    },
    *profileGroupTag({ payload: { values } }, { call, put }) {
      const response = yield call(crowPortrayal.getGroupInfo, { ...values });
      yield put({
        type: 'save',
        payload: {
          groupInfo: response?.data,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
